import type { HttpClient } from "../http";
import type { LedgerEntryDTO, StockAdjustmentRequest, StockLevelDTO } from "../types";

export function inventoryResource(http: HttpClient) {
  return {
    adjust: (body: StockAdjustmentRequest) =>
      http.post<LedgerEntryDTO>("/inventory/entries", body),
    stock: (skuId: number) => http.get<StockLevelDTO>(`/inventory/stock/${skuId}`),
    ledger: (skuId: number) => http.get<LedgerEntryDTO[]>(`/inventory/ledger/${skuId}`),
  };
}
